"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBSmallestInstallmentPositive = function SvgBSmallestInstallmentPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M131.658 103.849H25.428a2.107 2.107 0 01-2.107-2.108v-7.544a2.107 2.107 0 114.215 0v5.437H129.55V28.73a2.107 2.107 0 114.214 0v73.011a2.107 2.107 0 01-2.107 2.108z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M141.59 113.844H35.36a2.107 2.107 0 01-2.107-2.107v-8.52a2.107 2.107 0 014.215 0v6.413h102.015V38.725a2.107 2.107 0 114.215 0v73.012a2.107 2.107 0 01-2.107 2.107z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M120.117 57.361H53.982a2.107 2.107 0 110-4.214h66.135a2.107 2.107 0 010 4.214zM95.145 34.103H65.327a2.107 2.107 0 110-4.214h29.846a2.107 2.107 0 110 4.214h-.028zM108.457 44.162h-43.13a2.107 2.107 0 110-4.214h43.13a2.107 2.107 0 010 4.214z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M111.737 20.876H46.459a2.107 2.107 0 110-4.214h65.278a2.107 2.107 0 110 4.214z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M5.472 14.196a2.107 2.107 0 01-1.777-3.238A23.539 23.539 0 0123.645 0a2.107 2.107 0 010 4.215A19.338 19.338 0 007.248 13.22a2.107 2.107 0 01-1.777.976zM23.672 47.351h-.035A23.609 23.609 0 013.744 36.457a2.11 2.11 0 013.547-2.283 19.415 19.415 0 0016.353 8.963A19.465 19.465 0 0032.727 6.44a2.107 2.107 0 111.96-3.723 23.672 23.672 0 01-11.015 44.633z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M23.68 47.351a2.107 2.107 0 01-2.108-2.107V34.988a2.107 2.107 0 114.215 0v10.256a2.107 2.107 0 01-2.108 2.107z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M23.68 36.274a8.191 8.191 0 01-5.62-2.185 2.107 2.107 0 112.887-3.07 4.06 4.06 0 002.76 1.04c2.044 0 3.71-1.405 3.71-3.133v-.077c0-1.784-1.96-2.915-3.892-3.077a10.066 10.066 0 01-2.74-.583c-3.09-1.243-5.015-3.835-5.015-6.757a7.067 7.067 0 012.402-5.317 8.43 8.43 0 0111.07 0 2.107 2.107 0 11-2.81 3.118 4.01 4.01 0 00-2.71-.997 4.053 4.053 0 00-2.712.99 2.901 2.901 0 00-1.005 2.143c0 1.798 1.82 2.669 2.375 2.894a6.188 6.188 0 001.517.288c4.489.372 7.727 3.463 7.727 7.347v.078c-.014 4.039-3.576 7.298-7.945 7.298z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M23.665 12.981a2.107 2.107 0 01-2.107-2.107V2.107a2.107 2.107 0 114.214 0v8.767a2.107 2.107 0 01-2.107 2.107zM2.107 25.78a2.107 2.107 0 010-4.215H8.83a2.107 2.107 0 010 4.215H2.107zM121.522 93.888H15.454a2.107 2.107 0 01-2.108-2.107v-39.8a2.107 2.107 0 114.215 0v37.685h101.854V18.77a2.107 2.107 0 114.214 0v73.012a2.107 2.107 0 01-2.107 2.107z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M121.522 93.888H15.454a2.107 2.107 0 010-4.215h103.96V18.77a2.107 2.107 0 114.215 0v73.012a2.107 2.107 0 01-2.107 2.107z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M52.023 83.892a2.107 2.107 0 01-2.108-2.107V31.996a2.107 2.107 0 114.215 0v49.789a2.107 2.107 0 01-2.107 2.107zM41.957 60.628H25.393a2.107 2.107 0 010-4.215h16.564a2.107 2.107 0 110 4.215zM41.957 70.63H25.393a2.107 2.107 0 010-4.214h16.564a2.107 2.107 0 110 4.214zM41.957 80.626H25.393a2.107 2.107 0 010-4.215h16.564a2.107 2.107 0 110 4.215z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M61.948 83.927a2.107 2.107 0 01-2.107-2.107V65.285a2.107 2.107 0 014.214 0V81.82a2.107 2.107 0 01-2.107 2.107zM85.15 83.927a2.107 2.107 0 01-2.108-2.107V65.285a2.107 2.107 0 114.215 0V81.82a2.107 2.107 0 01-2.107 2.107zM98.377 83.927a2.107 2.107 0 01-2.108-2.107V65.285a2.107 2.107 0 014.215 0V81.82a2.107 2.107 0 01-2.107 2.107z",
    fill: "#285"
  }), (0, _core.jsx)("rect", {
    fill: "#285",
    x: 106.293,
    y: 63.177,
    width: 7.558,
    height: 20.743,
    rx: 3
  }), (0, _core.jsx)("rect", {
    fill: "#285",
    x: 69.717,
    y: 63.177,
    width: 7.558,
    height: 20.743,
    rx: 3
  })));
};

var _default = SvgBSmallestInstallmentPositive;
exports["default"] = _default;